jQuery(document).ready(function ($) {

    $('.sidebar-account-trigger').click(function () {
        let triggerElement = $('.sidebar-login');

        setTimeout(function () {
            if (triggerElement.hasClass('open')) {
                triggerElement.find('.input-text').on('input', function (e) {
                    let empty = true;
                    triggerElement.find('.input-text').each(function () {
                        if ($(this).val() != '') {
                            empty = false;
                        } else {
                            empty = true;
                        }
                    });

                    if (empty) {
                        triggerElement.find('.sc-button').addClass('states-disabled');
                    } else {
                        triggerElement.find('.sc-button').removeClass('states-disabled');
                    }
                });
            }
        }, 400);
    });

    $('#lost_pass_email').on('input', function (e) {
        let empty = true;
        if ($(this).val() != '') {
            empty = false;
        } else {
            empty = true;
        }

        if (empty) {
            $('.sc-button').addClass('states-disabled');
        } else {
            $('.sc-button').removeClass('states-disabled');
        }
    });

    /* $('#order_email').on('input', function (e) {
        let empty = true;
        if ($(this).val() != '') {
            empty = false;
        } else {
            empty = true;
        }

        if (empty) {
            $('.sc-button').addClass('states-disabled');
        } else {
            $('.sc-button').removeClass('states-disabled');
        }
    }); */

    // dev jorge
    /* const formState = {
        'manage-your-order': false,
        'manage-your-login': false,
    }; */

    /* const validateForm = (formHtml) => {
        let valid = true;
        let inputs = formHtml.find('input.required')

        // reset errors
        formHtml.find('.error-message').removeClass('block');

        // iterate all inputs
        inputs.each(function () {
            let item = jQuery(this);
            let value = jQuery(this).val().trim();

            // validate standar input "empty"
            if (value === '') {
                jQuery(item).closest('.input-group').find('.error-message').addClass('block')
                valid = false;
            }

            // validate input "email"
            if (jQuery(item).attr('type') === 'email') {
                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!regex.test(value)) {
                    jQuery(item).closest('.input-group').find('.error-message').addClass('block')
                    valid = false;
                }
            }

            // validate input type "password"
            if (jQuery(item).attr('type') === 'password') {
                if (value !== '' && value.length <= 7) {
                    jQuery(item).closest('.input-group').find('.error-message').addClass('block')
                    jQuery(item).closest('.input-group').find('.error-message').text(jQuery(item).attr('placeholder'))
                    valid = false;
                }
            }

            if (document.querySelector('.toggle-input[name="terms"]')) {
                if (jQuery('#sidebar-signup').hasClass('open')) {
                    if (!document.querySelector('.toggle-input[name="terms"]').checked) {
                        jQuery('.toggle-input[name="terms"]').closest('.toggle-group').find('.toggle-switch').css('background-color', 'var(--color-sc-color-destructive)');
                        valid = false;
                    } else {
                        jQuery('.toggle-input[name="terms"]').closest('.toggle-group').find('.toggle-switch').css('background-color', 'var(--color-black)');
                    }
                }
            }
        });
        return valid;
    } */

    /* const handleYourOrder = (formId) => {
        const allText = Array.from(document.querySelectorAll('.order-input'))
            .map(item => item.value.trim())
            .join('');

        // validamos que al menos 2 inputs tengan datos
        if (document.querySelectorAll('.order-input')[1].value === '' ||
            document.querySelectorAll('.order-input')[2].value === '') {
            jQuery('.error-message-order').show();
            return false;
        }

        jQuery.ajax({
            url: translations.ajax_url,
            type: 'POST',
            data: { action: 'woocommerce_ajax_check_my_order', orderNum: allText },
            beforeSend: () => {
                jQuery('.error-message-order').hide();
                jQuery('.btn-send-my-order').hide();
                jQuery('.spinner-my-order').show();
            },
            complete: () => {
                jQuery('.btn-send-my-order').show();
                jQuery('.spinner-my-order').hide();
            },
            success: function (data) {

                const response = data.data;
                jQuery('.error-message-order').show();
                if (data.success) {
                    jQuery('.error-message-order').text(`* ${response.tracking_status}`);
                } else {
                    jQuery('.error-message-order').text(`* ${response.message}`);
                }
            },
            error: (e) => {
                console.log(e);
            }
        });
    } */

    /* const handleYourLogin = (formId) => {
        const form = jQuery(`#${formId}`);
        formState[formId] = true;
        form.submit();
    }; */

    /* jQuery(document).on('submit', 'form.send-form', function (e) {

        const id = jQuery(this).attr('id');

        if (!formState[id]) {
            e.preventDefault();
            const $_form = jQuery(this);
            const isValid = validateForm($_form);
            if (!isValid) return false;
            $_form.trigger('form:validated', [id]);
        }
    }); */

    /* jQuery(document).on('form:validated', function (e, formId) {
        
        switch (formId) {
            case 'manage-your-order':
                handleYourOrder(formId);
                break;

            case 'manage-your-login':
                handleYourLogin(formId);
                break;
        }
    }); */

    // ==============================
    // === Lost password form validation ===  -- separamos responsabilidades por envio de formulario nativo
    // ==============================
    /* jQuery(document).on('submit', '.woocommerce-form-lost-password', function (e) {
        jQuery('.woocommerce-form-lost-password').find('.error-message').removeClass('block')
        if (jQuery('#lost_pass_email').val() === '') {
            jQuery(this).find('.error-message').addClass('block')
            e.preventDefault();
            return false;
        }
    }) */

    // ==============================
    // === Register form validation ===  -- separamos responsabilidades por envio de formulario nativo
    // ==============================
    /* jQuery(document).on('submit', '.woocommerce-form-register', function (e) {
        let form = jQuery(this);
        jQuery('.woocommerce-form-register').find('.error-message').removeClass('block')
        if (!validateForm(form)) {
            e.preventDefault();
            return false;
        }
    }) */
});

const formHandlers = [

]

const FormValidator = {

    resetField($input) {
        
        const $group = $input.closest('.input-group');
        $group.removeClass('is-invalid');
    },

    showFieldError($input) {
        const $group = $input.closest('.input-group');
        $group.addClass('is-invalid');
    },

    validateField($input) {

        const value = $input.val().trim();

        this.resetField($input);

        // required
        if ($input.hasClass('required') && value === '') {
            this.showFieldError($input);
            return false;
        }

        // email
        if ($input.attr('type') === 'email' && value !== '') {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regex.test(value)) {
                this.showFieldError($input);
                return false;
            }
        }

        // password
        if ($input.attr('type') === 'password') {

            if ($input.attr('data-length')) {

                const min_length = $input.attr('data-length');

                if (value !== '' && value.length < min_length) {
                    this.showFieldError($input);
                    return false;
                }
            }
        }

        return true;
    },

    validateForm($form) {

        let isValid = true;

        $form.find('input.required').each((_, input) => {
            const fieldValid = this.validateField(jQuery(input));
            if (!fieldValid) {
                isValid = false;
            }
        });

        return isValid;
    },

    canSubmit($form) {
        return this.validateForm($form);
    }
};

const OrderInputs = {

    init() {
        this.$inputs = jQuery('.order-input');
        if (!this.$inputs.length) return;

        this.bindEvents();
    },

    bindEvents() {
        this.$inputs.on('input', this.handleInput.bind(this));
        this.$inputs.on('keydown', this.handleKeydown.bind(this));
    },

    handleInput(e) {
        const index = this.$inputs.index(e.currentTarget);

        if (jQuery(e.currentTarget).val().length === 1 && index < this.$inputs.length - 1) {
            this.$inputs.eq(index + 1).focus();
        }
    },

    handleKeydown(e) {
        const index = this.$inputs.index(e.currentTarget);

        if (e.key === 'Backspace' && jQuery(e.currentTarget).val() === '' && index > 0) {
            this.$inputs.eq(index - 1).focus();
        }
    }
};

const FormSubmitHandlers = {

    // Handler de obtener info de seguimiento de pedido
    getOrderTrackingInfo($form) {

        const orderIdLength = 5;

        const $inputs = $form.find('.order-input');

        const orderId = $inputs.map(function () {
            return this.value.trim();
        }).get().join('');

        // Validación
        if (orderId.length != orderIdLength) {
            $form.find('.input-group').addClass('is-invalid');
            return;
        }

        jQuery.ajax({
            url: translations.ajax_url,
            type: 'POST',
            data: {
                action: 'woocommerce_ajax_check_my_order',
                orderNum: orderId,
                email: $form.find('input[name="email"]').val().trim()
            },
            beforeSend: () => {
                $form.find('.btn-send-my-order').hide();
                $form.find('.spinner-my-order').show();
            },
            complete: () => {
                $form.find('.btn-send-my-order').show();
                $form.find('.spinner-my-order').hide();
            },
            success: (data) => {
                const response = data.data;
                const $feedback_container = $form.find('.response-feedback');

                $feedback_container.text(
                    data.success
                    ? `* ${response.tracking_status}`
                    : `* ${response.message}`
                );
            },
            error: (e) => {
                console.error(e);
            }
        });
    }
}


jQuery(document).ready(function($) {

    // Validar campos de formularios a cada cambio
    jQuery(document).on('input change', 'form.sc-validate input.required', function () {
        FormValidator.validateField(jQuery(this));
    });

    // Validación genérica de campos requeridos en formularios
    jQuery(document).on('submit', 'form.sc-validate', function (e) {

        const $form = jQuery(this);

        // 1. Validación común
        if (!FormValidator.canSubmit($form)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }

        // 2. Decidir tipo de submit
        const submitType = $form.data('submit');

        if (submitType === 'ajax') {
            e.preventDefault();

            const handlerName = $form.data('handler');
            const handler = handlerName ? FormSubmitHandlers[handlerName] : null;

            if (typeof handler === 'function') {
                handler($form);
            } else {
                console.warn('[sc-validate] Handler not found:', handlerName);
            }

            return false;
        }

        // submit nativo
    });

    // Actualizar contador de carácteres en campo contraseña de registro
    jQuery(document).on('input', '#reg_password', function (e) {

        const $input = jQuery(this);

        const password = $input.val();
        const password_length = password.length;

        const min_length = $input.data('length');

        // Update length counter
        jQuery('#customer_register .number-password').text(`${password_length}/${min_length}`);
    })

    // Gestión de los inputs para seguimiento de pedido
    OrderInputs.init();

})